import ArrowBackBtn from './ArrowBackBtn.jsx';

export default ArrowBackBtn;


// WEBPACK FOOTER //
// ./src/components/ArrowBackBtn/index.jsx